import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

const Cancel = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const orderId = searchParams.get("order_id");

  // Optional: Log canceled payment (e.g., for analytics)
  useEffect(() => {
    console.log(`Payment canceled for order: ${orderId}`);
  }, [orderId]);

  const handleRetry = () => {
    navigate("/payment"); // Redirect to payment page to retry
  };

  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      <h1>Payment Canceled</h1>
      <p>Your payment for Order ID: <strong>{orderId}</strong> was not completed.</p>
      
      <div style={{ margin: "1.5rem 0" }}>
        <button 
          onClick={handleRetry}
          style={{
            padding: "0.5rem 1rem",
            background: "#4CAF50",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            marginRight: "1rem",
          }}
        >
          Retry Payment
        </button>
        
        <button 
          onClick={() => navigate("/")}
          style={{
            padding: "0.5rem 1rem",
            background: "#f44336",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Return Home
        </button>
      </div>

      <p>If this was a mistake, please try again.</p>
    </div>
  );
};

export default Cancel;